import type { Request } from '@/lib/dd-queue/types'
import type { ResolvedSubject } from '@/lib/dd-queue/resolveSubject'

const DAY_MS = 86_400_000
const APP_START = Date.now()

/** Unix-ms anchor for Age/Turnaround — reference queue-store.ts L28–31. */
export function triageAnchor(seed: { triageEnteredAt?: number; age: number }): number {
  return seed.triageEnteredAt ?? APP_START - (seed.age ?? 0) * DAY_MS
}

/**
 * Total order turnaround — reference turnaround.ts L12–17.
 * From triage entry to latest deliverableCompletedAt (session-only).
 */
export function orderTurnaroundMs(_req: Request, resolved: Pick<ResolvedSubject, 'triageEnteredAt' | 'deliverableCompletedAt'>): number | null {
  const completions = Object.values(resolved.deliverableCompletedAt ?? {})
  if (completions.length === 0) return null
  const completedAt = Math.max(...completions)
  const ms = completedAt - resolved.triageEnteredAt
  return ms >= 0 ? ms : null
}

/** Format turnaround duration — reference turnaround.ts L21–30. */
export function fmtTurnaround(ms: number): string {
  const days = ms / DAY_MS
  if (days >= 1) {
    const d = Math.floor(days)
    const h = Math.round((days - d) * 24)
    return h > 0 ? `${d}d ${h}h` : `${d}d`
  }
  const h = ms / 3_600_000
  if (h >= 1) return `${h.toFixed(1)}h`
  return `${Math.max(1, Math.round(ms / 60_000))}m`
}
